import gql from 'graphql-tag';

export const getUtpAdsData = gql`
  query getUTPAds {
    ads {
      advertisement {
        idCampaing
        name
        title
        message
        termsLink
        dateStart
        dateEnd
        isInternal
        target
      }
    }
  }
`;
